import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {CoreSidebarService} from '../../../@core/components/core-sidebar/core-sidebar.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup} from '@angular/forms';
import {AlertService} from '../../shared/services/alert.service';
import {ProgramService} from '../../shared/services/program.service';
import {StorageService} from '../../shared/services/storage.service';
import {StageService} from '../../shared/services/stage.service';
import {ReasonService} from '../../shared/services/reason.service';
import {SrMappingService} from '../../shared/services/sr-mapping.service';

import {CounsellorService} from '../../shared/services/counsellor.service';

@Component({
    selector: 'app-programs',
    templateUrl: './programs.component.html',
    styleUrls: ['./programs.component.scss']
})
export class ProgramsComponent implements OnInit {
    showSearch = false;
    id: any;
    data: any;
    updatePasswordForm: FormGroup;
    inputTypePassword = 'password';
    submitted: any = false;
    submitting: any = false;
    searchForm: FormGroup;

    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    programs = [];



    constructor(private router: Router,
                private _coreSidebarService: CoreSidebarService,
                private stageService: StageService,
                private reasonService: ReasonService,
                private srMappingService: SrMappingService,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private counsellorService: CounsellorService,
                private programService: ProgramService,
                private alertService: AlertService) {

    }

    ngOnInit(): void {
        this.refresh();

    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-program').toggleOpen();
    }

    add(): void {
        this.data = undefined;
        this.toggleSidebar();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'name': [''],
        });
        this.get();

    }


    getData(valueSubmit: any): void {
        if (valueSubmit) {
            this.get({page: 1, total: null, perpage: 15, pages: null});
            this.toggleSidebar();
        }
    }

    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.programs = [];
        this.programService.get(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.programs = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.programs = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }



    search() {
        const params = {
            'name': (this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
        };
        this.get(params);
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            'name': (this.searchForm && this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
        };
        this.get(params);
    }

    edit(data) {
        this.data = data;
        this.toggleSidebar();
    }



    updateStatus(status, data) {
        this.submitted = true;
        if (this.submitted) {
            const params = {
                'status': status
            };
            this.submitting = true;
            this.programService.updateStatus(data.id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
                this.modalService.dismissAll('');
                this.get();
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
            });
        }
    }




}
